/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthService } from 'services/auth.service';
import ScreenLoading from 'components/organisms/ScreenLoading';
import { redirectToCandidate, redirectToCompany } from 'utils/redirect';

const LinkedinRedirect = () => {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get('reference') ?? '';
  const redirectPath = window.atob(reference);

  const handleError = (message?: string) => {
    window.opener?.postMessage({ error: message ?? 'error' }, '*');
    window.close();
  };

  const linkedinAuthentication = async (
    code: string,
    state: string,
    isCompany: boolean
  ) => {
    try {
      const { data } = await AuthService.linkedinAuthentication({
        state,
        code,
        isCompany
      });
      window.opener?.postMessage({ token: data.token }, '*');
      setInterval(() => window.close(), 500);
    } catch (error) {
      handleError();
    }
  };

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state')?.split(',')[0];
    const isCompany = searchParams.get('state')?.split(',')[1] === 'true';
    const error = searchParams.get('error');

    if (error) {
      error === 'user_cancelled_login'
        ? handleError('canceled')
        : handleError();
    }

    if (code && state) {
      linkedinAuthentication(code, state, isCompany);
    }
  }, []);

  return <ScreenLoading />;
};

export default LinkedinRedirect;
